import React from 'react'
import { Input } from '@mobi/component-library/Selection&Input/Inputs'
import { InfoBox } from '@mobi/component-library/Feedback/InfoBox'
import { getNameValidationMessage } from '@mobi/account/Areas/SignUp/Utils'

type Props = {
  firstName: string
  middleName: string
  lastName: string
  setFirstName: (value: string) => void
  setMiddleName: (value: string) => void
  setLastName: (value: string) => void
  isDisabled: boolean
}

export const NameInput = ({
  firstName,
  middleName,
  lastName,
  setFirstName,
  setMiddleName,
  setLastName,
  isDisabled,
}: Props) => {
  const [focusedField, setFocusedField] = React.useState<string | null>(null)
  const [validationMessages, setValidationMessages] = React.useState<Record<string, string>>({})

  const handleFocus = (fieldName: string) => {
    setFocusedField(fieldName)
  }

  const removeFocus = (fieldName: string) => {
    if (focusedField === fieldName) setFocusedField(null)
  }

  const resetFieldValidation = (field: keyof typeof validationMessages) =>
    setValidationMessages(prev => ({
      ...prev,
      [field]: '',
    }))

  return (
    <>
      <Input
        label='First name'
        name='firstName'
        placeholder='Details must match your ID'
        required
        maxLength={50}
        value={firstName}
        onChange={e => setFirstName(e.target.value)}
        onFocus={() => {
          resetFieldValidation('firstName')
          handleFocus('firstName')
        }}
        onBlur={e => {
          removeFocus('firstName')
          setValidationMessages(prev => ({
            ...prev,
            firstName: getNameValidationMessage(e.target.value),
          }))
        }}
        isInvalid={!!validationMessages.firstName}
        helpText={validationMessages.firstName}
        isDisabled={isDisabled}
      />
      {focusedField === 'firstName' && (
        <InfoBox color='blue' size='sm'>
          Your name must match your ID documents
        </InfoBox>
      )}

      <Input
        label='Middle name (if applicable)'
        name='middleName'
        placeholder='Details must match your ID'
        maxLength={50}
        value={middleName}
        onChange={e => setMiddleName(e.target.value)}
        onFocus={() => {
          resetFieldValidation('middleName')
          handleFocus('middleName')
        }}
        onBlur={e => {
          removeFocus('middleName')
          setValidationMessages(prev => ({
            ...prev,
            middleName: getNameValidationMessage(e.target.value, true),
          }))
        }}
        isInvalid={!!validationMessages.middleName}
        helpText={validationMessages.middleName}
        isDisabled={isDisabled}
      />
      {focusedField === 'middleName' && (
        <InfoBox color='blue' size='sm'>
          Your name must match your ID documents
        </InfoBox>
      )}

      <Input
        label='Last name'
        name='lastName'
        placeholder='Details must match your ID'
        required
        maxLength={50}
        value={lastName}
        onChange={e => setLastName(e.target.value)}
        onFocus={() => {
          resetFieldValidation('lastName')
          handleFocus('lastName')
        }}
        onBlur={e => {
          removeFocus('lastName')
          setValidationMessages(prev => ({
            ...prev,
            lastName: getNameValidationMessage(e.target.value),
          }))
        }}
        isInvalid={!!validationMessages.lastName}
        helpText={validationMessages.lastName}
        isDisabled={isDisabled}
      />
      {focusedField === 'lastName' && (
        <InfoBox color='blue' size='sm'>
          Your name must match your ID documents
        </InfoBox>
      )}
    </>
  )
}
